<template>
  <ul uk-tab class="uk-margin-medium-bottom">
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-product', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.basics')}}</a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-protocols', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.protocols')}}
          <span v-if="kompaProduct && kompaProduct.protocols">*</span>
          
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-adapters', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.adapters')}}
          <span v-if="kompaProduct && kompaProduct.adapters">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-appliances', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.appliances')}}
          <span v-if="kompaProduct && kompaProduct.appliances">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-cameras', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.cameras')}}
          <span v-if="kompaProduct && kompaProduct.cameras">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-climate-devices', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.climateDevices')}}
          <span v-if="kompaProduct && kompaProduct.climateDevices">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-extensions', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.extensions')}}
          <span v-if="kompaProduct && kompaProduct.extensions">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-gateway-bridges', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.gatewayBridges')}}
          <span v-if="kompaProduct && kompaProduct.gatewayBridges">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-door-locks', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.doorLocks')}}
          <span v-if="kompaProduct && kompaProduct.doorLocks">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-lightnings', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.lightnings')}}
          <span v-if="kompaProduct && kompaProduct.lightnings">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-motion-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.motionSensors')}}
          <span v-if="kompaProduct && kompaProduct.motionSensors">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-mounted-devices', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.mountedDevices')}}
          <span v-if="kompaProduct && kompaProduct.mountedDevices">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-outdoor', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.outdoor')}}
          <span v-if="kompaProduct && kompaProduct.outdoor">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-remote-controls', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.remoteControls')}}
          <span v-if="kompaProduct && kompaProduct.remoteControls">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{name: 'edit-kompa-internet-routers', params: {id}}"
        exact-active-class="uk-native"
      >
        <a>{{$t('tabs.internetRouters')}}
          <span v-if="kompaProduct && kompaProduct.internetRouters">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-shutter-and-gates', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.shutterAndGates')}}
          <span v-if="kompaProduct && kompaProduct.shutterAndGates">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-sirens', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.sirens')}}
          <span v-if="kompaProduct && kompaProduct.sirens">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-smoke-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.smokeSensors')}}
          <span v-if="kompaProduct && kompaProduct.smokeSensors">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-speakers', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.speakers')}}
          <span v-if="kompaProduct && kompaProduct.speakers">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-various-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.variousSensors')}}
          <span v-if="kompaProduct && kompaProduct.variousSensors">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-switches', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.switches')}}
          <span v-if="kompaProduct && kompaProduct.switches">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-door-window-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.doorWindowSensors')}}
          <span v-if="kompaProduct && kompaProduct.doorWindowSensors">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-integrated-systems', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.integratedSystems')}}
          <span v-if="kompaProduct && kompaProduct.integratedSystems">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-water-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.waterSensors')}}
          <span v-if="kompaProduct && kompaProduct.waterSensors">*</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        :to="{ name: 'edit-kompa-weather-sensors', params: { id } }"
        exact-active-class="uk-active"
      >
        <a>{{$t('tabs.weatherSensors')}}
          <span v-if="kompaProduct && kompaProduct.weatherSensors">*</span>
        </a>
      </router-link>
      <router-link tag="li" :to="{name: 'edit-kompa-media-receivers', params: {id}}" exact-active-class="uk-native">
        <a>{{$t('tabs.mediaReceivers')}}
          <span v-if="kompaProduct && kompaProduct.mediaReceivers">*</span>
        </a>
      </router-link>
    </ul>
</template>
<script>

import View from '@/mixins/View';
import kompaProductQuery from '@/api/queries/kompa-product.graphql';

export default {
  name: 'kompa-edit-navigation',
  mixins: [
    View,
  ],
  components: {
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  apollo: {
    kompaProduct: {
      query: kompaProductQuery,
      variables() {
        return { id: this.id };
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  i18n: {
    messages: {
      de: {
        tabs: {
          basics: 'Produkt',
          protocols: 'Funkprotokolle',
          adapters: 'Zwischenstecker',
          appliances: 'Haushaltsgeräte',
          cameras: 'Kameras',
          climateDevices: 'Heizungs- und Klimasteuerung',
          doorLocks: 'Türen & Schlösser',
          extensions: 'Erweiterungen',
          gatewayBridges:
            'Erweiterungen: Funksticks, Hersteller-Gateways und Bridges',
          lightnings: 'Beleuchtung',
          motionSensors: 'Melder & Sensoren: Bewegungsmelder',
          mountedDevices: 'Auf- und Unterputzgeräte',
          outdoor: 'Outdoor',
          remoteControls: 'Fernbedienungen',
          internetRouters: 'Internet Router',
          shutterAndGates: 'Rollläden, Jalousien und Tore',
          sirens: 'Sirenen',
          smokeSensors: 'Rauchmelder',
          speakers: 'Lautsprecher',
          variousSensors: 'Melder & Sensoren: Weitere',
          switches: 'Schalter & Taster',
          doorWindowSensors: 'Melder & Sensoren: Tür-/Fensterkontakte',
          integratedSystems: 'Integrierte Systeme',
          waterSensors: 'Wassersensoren',
          weatherSensors: 'Wettersensoren',
          mediaReceivers: 'Media Receiver',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// KompaEditNavigation.vue?4f74bc40